import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { ListingCard, PaginationLinks } from '../../components';
import { Tooltip } from 'react-tooltip';
import css from './SearchResultsPanel.module.css';

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    isMobileLayout,
    disableAllRootedRent,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  const toolTipStyle = { maxWidth: '300px', zIndex: 99, lineHeight: 1.2 };
  const toolTipPlace = !!isMobileLayout ? 'bottom-end' : 'top-end'; 
  return (
    <div className={classes}>
      <div className={css.listingCards}>
        {listings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes}
            setActiveListing={setActiveListing}
            isMobileLayout={isMobileLayout}
            disableAllRootedRent={disableAllRootedRent}
          />
        ))}
        {props.children}
        <div>
          <Tooltip
            id={`tag-greatDeal`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-niceAmenities`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-utilitiesIncluded`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-incomeAndCreditFriendly`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-furnished`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-refundedApplication`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-securityDepositProgram`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
          <Tooltip
            id={`tag-petFriendly`}
            place={toolTipPlace}
            openOnClick={!!isMobileLayout}
            style={toolTipStyle}
          />
        </div>
      </div>
      {paginationLinks}
    </div>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
  disableAllRootedRent: false,
};

const { array, node, object, string } = PropTypes;

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
};

export default SearchResultsPanel;
